"use client"

import { Eraser } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `EraserIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const EraserIcon = component(Icon)({ as: Eraser })
